import { render, staticRenderFns } from "./StoreDiscountList.vue?vue&type=template&id=6f92f34c&"
import script from "./StoreDiscountList.vue?vue&type=script&lang=js&"
export * from "./StoreDiscountList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports